// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_fullScreen__-NizT {
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #f5f5f5;
  transition: all 0.4s; }

.style_modal__\\+y-4Q {
  width: 560px;
  height: 70vh; }

.style_container__q\\+j3u {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 30px; }

.style_header__dOLTM {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px; }
  .style_header__dOLTM h2 {
    font-family: Inter;
    font-weight: 600;
    line-height: 150%; }

.style_footer__fyzBk {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding-top: 10px;
  border-top: 1px solid var(--product-on-surface-divider, #e0e0e0);
  background: var(--website-white, #fff); }

.style_content__8R0ES {
  display: flex;
  height: calc(100% - 150px);
  margin-bottom: 10px;
  flex-direction: column; }
  .style_content__name__zPXSX {
    font-weight: 600;
    line-height: 24px;
    padding: 10px;
    background: #ffffff; }
  .style_content__list__1pkiY {
    height: 100%;
    overflow: auto; }

.style_cross__5PQHK {
  cursor: pointer;
  transition: all 0.4s; }
  .style_cross__5PQHK:hover {
    transform: scale(1.1); }

.style_select__Nlbm\\+ {
  display: flex;
  gap: 10px; }
  .style_select__active__SoyZ5 {
    padding: 4px 8px;
    border-radius: 16px;
    background: #fe6100;
    color: white;
    cursor: pointer; }
  .style_select__noActive__vLY2w {
    color: '#212121';
    padding: 4px 8px;
    border-radius: 16px;
    background: rgba(33, 33, 33, 0.08);
    cursor: pointer; }

.style_paramInputs__YJUI2 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 47px;
  width: 120px; }

.style_minIntervalInfo__DZNjU {
  font-size: 12px;
  text-align: center; }
`, "",{"version":3,"sources":["webpack://./src/pages/OrdersViewD3/style.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,oBAAoB,EAAA;;AAEtB;EACE,YAAY;EACZ,YAAY,EAAA;;AAEd;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa,EAAA;;AAEf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB,EAAA;EAHrB;IAKI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAA;;AAGrB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,gEAAgE;EAChE,sCAAsC,EAAA;;AAExC;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EAEnB,sBAAsB,EAAA;EACtB;IACE,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB,EAAA;EAErB;IACE,YAAY;IACZ,cAAc,EAAA;;AAGlB;EACE,eAAe;EACf,oBAAoB,EAAA;EAFtB;IAII,qBAAqB,EAAA;;AAIzB;EACE,aAAa;EACb,SAAS,EAAA;EACT;IACE,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,YAAW;IACX,eAAe,EAAA;EAEjB;IACE,gBAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kCAAkC;IAClC,eAAe,EAAA;;AAInB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,YACF,EAAA;;AAEA;EACE,eAAe;EACf,kBAAkB,EAAA","sourcesContent":[".fullScreen {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  background-color: #f5f5f5;\n  transition: all 0.4s;\n}\n.modal {\n  width: 560px;\n  height: 70vh;\n}\n.container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 30px;\n}\n.header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  h2 {\n    font-family: Inter;\n    font-weight: 600;\n    line-height: 150%;\n  }\n}\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  padding-top: 10px;\n  border-top: 1px solid var(--product-on-surface-divider, #e0e0e0);\n  background: var(--website-white, #fff);\n}\n.content {\n  display: flex;\n  height: calc(100% - 150px);\n  margin-bottom: 10px;\n\n  flex-direction: column;\n  &__name {\n    font-weight: 600;\n    line-height: 24px;\n    padding: 10px;\n    background: #ffffff;\n  }\n  &__list {\n    height: 100%;\n    overflow: auto;\n  }\n}\n.cross {\n  cursor: pointer;\n  transition: all 0.4s;\n  &:hover {\n    transform: scale(1.1);\n  }\n}\n\n.select {\n  display: flex;\n  gap: 10px;\n  &__active {\n    padding: 4px 8px;\n    border-radius: 16px;\n    background: #fe6100;\n    color:white;\n    cursor: pointer;\n  }\n  &__noActive {\n    color:'#212121';\n    padding: 4px 8px;\n    border-radius: 16px;\n    background: rgba(33, 33, 33, 0.08);\n    cursor: pointer;\n  }\n}\n\n.paramInputs{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-top: 47px;\n  width: 120px\n}\n\n.minIntervalInfo{\n  font-size: 12px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullScreen": `style_fullScreen__-NizT`,
	"modal": `style_modal__+y-4Q`,
	"container": `style_container__q+j3u`,
	"header": `style_header__dOLTM`,
	"footer": `style_footer__fyzBk`,
	"content": `style_content__8R0ES`,
	"content__name": `style_content__name__zPXSX`,
	"content__list": `style_content__list__1pkiY`,
	"cross": `style_cross__5PQHK`,
	"select": `style_select__Nlbm+`,
	"select__active": `style_select__active__SoyZ5`,
	"select__noActive": `style_select__noActive__vLY2w`,
	"paramInputs": `style_paramInputs__YJUI2`,
	"minIntervalInfo": `style_minIntervalInfo__DZNjU`
};
export default ___CSS_LOADER_EXPORT___;
